const CREW_MEMBER_CLASS_CHOICES = {
    J: 'Journeyman',
    Y: 'Yard',
    A_1: 'A1',
    A_2: 'A2',
    A_3: 'A3',
    A_4: 'A4',
    A_5: 'A5',
    A_6: 'A6',
    A_7: 'A7',
    A_8: 'A8',
    F: 'Foreman',
    S: 'Superintendent',
    A: 'Admin',
    C: 'Clerk',
}

export function cleanCrewMembersData(crewMembers, filterBy) {

    return crewMembers.filter(member => {
        switch(filterBy) {
            case 'active':
                return member.isActive

            case 'inactive':
                return !member.isActive
                
            default:
                return true
        }
    }).map(member => {

        return {
            ...member,
            phone: member.phone ? member.phone : "",
            email: member.email ? member.email : "",
            name: `${member.firstName} ${member.lastName}`,
            classification: member.classification ? CREW_MEMBER_CLASS_CHOICES[member.classification] : ""
        }
    })
}